import React from 'react'
import { Spin } from 'antd'
import { ChartBox } from '../../../../ResultPanel/component/ChartBox'
import RoseChartPlotly from "../../../../../common/Chart/RoseChartPlotly"
import styles from '../../Layout/AnalyticsLayout.module.scss'
import { IBestDataset } from "../../../../../../types/analytics"
import ErrorDisplay from "../../ErrorDisplay";

interface RosePlotChartProps {
  rosePlotData: any[]
  rosePlotSeries: any[]
  pointName: string
  coordinates: { lng: string; lat: string }
  directionChartNo: number
  unitX: string
  downloadName: string
  selectedDatasetInfo?: IBestDataset
  isLoading?: boolean
  error?: string
  isOffline: boolean
}

export const RosePlotChart = ({
    rosePlotData,
    rosePlotSeries,
    pointName,
    coordinates,
    directionChartNo,
    unitX,
    downloadName,
    selectedDatasetInfo,
    isLoading = false,
    error,
    isOffline
  }: RosePlotChartProps) => {

  if (error || isOffline) {
    return (
      <ErrorDisplay
        error={error}
        isOfflineDataset={isOffline}
      />
    )
  }

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}>
        <Spin size="large" />
      </div>
    )
  }

  if(rosePlotData.length === 0 || rosePlotSeries.length === 0){
    return (
      <ErrorDisplay
        error="No data available"
      />
    )
  }

  return (
    <div className={styles.chartPointWrapper}>
      <div className={styles.analyticsPointName}>
        {pointName}
        <span className={styles.analyticsCoords}>
          ({coordinates.lng}°E; {coordinates.lat}°N)
        </span>
      </div>

      <div className={styles.chartContainer}>
        <ChartBox
          key="Rose Plot"
          title="Rose Plot"
          height={500}
          plot={
            <RoseChartPlotly
              id="Analytics-RosePlot-Plot"
              series={rosePlotSeries}
              data={rosePlotData}
              angle={-360 / directionChartNo / 2 - 90}
              unitX={unitX}
              downloadName={downloadName}
            />
          }
          dataset={selectedDatasetInfo?.label || ''}
        />
      </div>
    </div>
  )
}

export type { RosePlotChartProps }
